<template>
  <div
    class="cxm-TagEditable"
    :style="setHeight"
  >
    <Input
      style="width: 100%;"
      v-model="value"
      :error-message="isInvalid"
      :placeholder="$t('survey.new.question_placeholder')"
    />
    <Tooltip :text="tooltipRemove">
      <Icon
        name="Trash"
        size="20"
        :handle-click="handleRemove"
        color="var(--track-color-bluegray-80)"
      />
    </Tooltip>
  </div>
</template>

<script>
import { Input, Icon } from '@/packages/ui/components';
import Tooltip from '@/packages/ui/components/Tooltip/Tooltip.vue';

export default {
  components: {
    Tooltip,
    Icon,
    Input,
  },
  props: {
    id: {
      type: [String, Number],
      default: 0,
    },
    text: {
      type: String,
      default: '',
    },
    tooltipRemove: {
      type: String,
      default: 'Remove',
    },
    isInvalid: {
      type: String,
      default: '',
    },
  },
  computed: {
    data() {
      return {
        id: this.id,
      };
    },
    value: {
      get() {
        return this.text;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    setHeight() {
      if (this.isInvalid) {
        return 'height: 60px';
      }
      return '';
    },
  },
  methods: {
    handleRemove() {
      this.$emit('remove', this.data);
    },
  },
};
</script>

<style lang="scss" scoped>
.cxm-TagEditable {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
}
</style>
